import React from 'react';
import { Table } from 'reactstrap';
function createMarkup() {
  return { __html: 'First &middot; Second' };
}
const OrderItem = props => {
  return (
    <Table responsive hover className="ps-table">
      <thead>
        <tr>
          <th>Product No.</th>
          <th>Name</th>
          <th>Unit</th>
          <th>Quantity</th>
          <th>Price</th>
          <th>Type</th>
          <th colSpan="2">Data</th>
        </tr>
      </thead>
      <tbody>
        {props.state.items.length < 1 && (
          <tr>
            <td colSpan="8">
              <div className="ps-empty-data">
                <div className="empty-content">
                  <h4>No data to show</h4>
                </div>
              </div>
            </td>
          </tr>
        )}

        {props.state.items.length > 0 &&
          props.state.items.map((item, index) => {
            let report = '';
            let brand = '';
            let customdata = '';
            if (item.data) {
              for (let i of JSON.parse(item.data)) {
                report += i.name + ' - ' + i.data + '\n';
              }
            }
            if (item.custom_product === 'SZW_SERVICE') {
              if (item.custom_data) {
                let data = JSON.parse(item.custom_data);
                customdata = data;
                brand = data.brand;
                report +=
                  data.brand +
                  (data.delivery_date && ' - ') +
                  data.delivery_date +
                  (data.model && ' - ') +
                  data.model +
                  (data.serial_no && ' - ') +
                  data.serial_no;
                // report += '\n\n Parts Replacement\n';
                // if (data.parts.length > 0) {
                //   for (let j of data.parts) {
                //     report +=
                //       j.qty + ' - ' + j.product_no + ' - ' + j.price + '\n';
                //   }
                // } else {
                //   report += 'None\n';
                // }
              }
            }

            if (item.service_report) {
              if (item.custom_product === 'SZW_SERVICE') {
                let data = JSON.parse(item.service_report);
                //console.log(data);
                let sdata = data.find(x => x.Brand === brand);
                let int = 0;

                if (sdata) {
                  for (let i of sdata.Diagnosis) {
                    if (i.Checklist.length > 0) {
                      for (let j of i.Checklist) {
                        if (j.Check) {
                          int++;
                          if (int === 1) report += '\n\n Service Report\n';
                          report += i.Title + ' - ' + j.Item;
                        }
                      }
                    }
                  }

                  if (sdata.Remarks) {
                    report += '\n Remark\n ';
                    report += sdata.Remarks;
                  }

                  report += '\n\n Proposed Replacement Parts\n';

                  if (
                    sdata.hasOwnProperty('Replacement_Parts') &&
                    sdata.Replacement_Parts !== null &&
                    sdata.Replacement_Parts.length > 0
                  ) {
                    for (let j of sdata.Replacement_Parts) {
                      report +=
                        j.qty + ' - ' + j.product_no + ' - ' + j.price + '\n';
                    }
                  } else {
                    report += 'None';
                  }
                }
              }
            }

            // if (item.custom_data) {
            //   report += '\n\n Proposed Replacement Parts\n';
            //   let data = JSON.parse(item.custom_data);
            //   if (data.parts.length > 0) {
            //     for (let j of data.parts) {
            //       report +=
            //         j.qty + ' - ' + j.product_no + ' - ' + j.price + '\n';
            //     }
            //   } else {
            //     report += 'None';
            //   }
            // }

            return (
              <tr key={index}>
                <td>{item.product_no}</td>
                <td>{item.name}</td>
                <td>{item.unit}</td>
                <td>{item.qty}</td>
                <td>{item.price}</td>
                <td>{item.product_type}</td>
                <td colSpan="2">
                  {report.split('\n').map((str, index) => {
                    return <p key={index}>{str}</p>;
                  })}
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default OrderItem;
